module.exports = __webpack_public_path__ + "img/dianchi-60.9df0c22b.png";